@let organizationNameValue = organizationName();

<div class="login-configuration__container" (keyup.enter)="verifyLoginConfiguration()">
  @if (errorMessageTranslationKey(); as errorMessageTranslationKey) {
    <div class="login-configuration__error-banner">
      <kds-banner [type]="BannerType.Error" [bannerText]="errorMessageTranslationKey | translate" />
    </div>
  }

  @if (organizationNameValue) {
    <div class="login-configuration__log-in-to-section">
      <span class="login-configuration__log-in-to">
        {{ 'login.configuration.log-in-to' | translate }}
      </span>
      <span class="login-configuration__organization-name">{{ organizationNameValue }}</span>
      <a kds-link class="login-configuration__switch-organization" (click)="clearOrganizationName()">
        {{ 'login.configuration.buttons.switch-organization' | translate }}
      </a>
    </div>
  }

  <form class="login-configuration__input" (submit)="$event.preventDefault()">
    <kds-input
      elementId="username"
      autocomplete="username"
      [detectAutofill]="true"
      [label]="'login.configuration.labels.username' | translate"
      [autoFocus]="true"
      [componentFormControl]="loginConfigurationForm().controls.username"
    >
      @if (organizationNameValue) {
        <a
          kds-link
          kdsPrefetch
          [routerLink]="['/', ApplicationPath.CannotLogin, LoginRecoveryPath.ForgotUsername]"
          (keyup.enter)="$event.stopPropagation()"
        >
          {{ 'login.configuration.forgot-password-link' | translate }}
        </a>
      }
    </kds-input>
  </form>

  @if (!organizationNameValue) {
    <div class="login-configuration__organization-name-input">
      <kds-input
        elementId="organizationName"
        autocomplete="organization"
        [label]="'login.configuration.labels.organization-name' | translate"
        [componentFormControl]="loginConfigurationForm().controls.organizationName"
      />
    </div>
  }

  <div class="login-configuration__button">
    <kds-large-button
      [buttonText]="'login.configuration.buttons.next' | translate"
      [loading]="loginConfigurationLoading()"
      (buttonClick)="verifyLoginConfiguration()"
    />
  </div>

  @if (organizationNameValue) {
    @if (isSsoEnabled()) {
      <div class="login-configuration__separator">
        <span class="login-configuration__separator-line"></span>
        <span class="login-configuration__separator-text">{{ 'login.flow.separator-text' | translate }}</span>
        <span class="login-configuration__separator-line"></span>
      </div>
      <div class="login-configuration__sso-login">
        <kds-large-icon-button
          iconClass="fa-regular fa-shield-keyhole"
          colorScheme="secondary"
          [buttonText]="'login.flow.buttons.log-in-with-sso' | translate"
          (buttonClick)="logInWithThirdPartySSO()"
        />
      </div>
    }

    @if (isBookmarkTip()) {
      <div class="login-configuration__tip-container">
        <kds-banner>
          <i custom-icon class="fa-regular fa-lightbulb fa--icon-link"></i>
          <div class="login-configuration__tip-banner">
            <span class="login-configuration__tip">{{ 'login.configuration.tip' | translate }}</span>
            <span>{{ 'login.configuration.bookmark-tip' | translate }}</span>
            <i class="login-configuration__close-tip fa-regular fa-xmark" (click)="closeBookmarkTip()"></i>
          </div>
        </kds-banner>
      </div>
    }
  } @else {
    <a kds-link class="login-configuration__forgot-password" kdsPrefetch [routerLink]="['/', ApplicationPath.CannotLogin]">
      {{ 'login.options.forgot-credentials' | translate }}
    </a>
  }

  @if (isZendeskLoginFlow()) {
    <div class="login-configuration__helpdesk-banner">
      <kds-banner typeIconPosition="baseline" [type]="BannerType.Information">
        <div class="login-configuration__helpdesk-content">
          <span class="login-configuration__helpdesk-title">{{ 'login.helpdesk.title' | translate }}</span>
          <span>{{ 'login.helpdesk.no-access' | translate }}</span>
          <span class="login-configuration__helpdesk-link-tip">
            {{ 'login.helpdesk.other-issues' | translate }}
            <a kds-link target="_blank" rel="noopener noreferrer" [href]="helpdeskLink">
              {{ 'login.helpdesk.support-link' | translate }}
            </a>
            <span>.</span>
          </span>
        </div>
      </kds-banner>
    </div>
  }

  <div class="login-configuration__separator">
    <span class="login-configuration__separator-line"></span>
  </div>

  <itc-mobile-app-links />
</div>
